/* Pタグ_中央寄せ */
import React from 'react';
import { convertLine } from '../utils/Convert';

type Props = {
  label: string;
};

const CenterParagraph: React.FC<Props> = ({ label }) => {
  //改行\nがlabelに存在する場合はエスケープを外す。
  return <div className={`center-paragraph bottom-border`}>{convertLine(label)}</div>;
};

export default CenterParagraph;
